import { render, staticRenderFns } from "./TempRenewal.vue?vue&type=template&id=f8375ad4&scoped=true"
import script from "./TempRenewal.vue?vue&type=script&lang=js"
export * from "./TempRenewal.vue?vue&type=script&lang=js"
import style0 from "./TempRenewal.vue?vue&type=style&index=0&id=f8375ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8375ad4",
  null
  
)

export default component.exports